import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Stack,
  Breadcrumbs,
  Link,
  IconButton,
  Button,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NotificationsIcon from "@mui/icons-material/Notifications";
import "./displaySite.css";
import { callUnsetApi } from "utils/api";

const DisplaySite = () => {
  const stateName = sessionStorage.getItem("selectedState");
  const [searchTerm, setSearchTerm] = useState("");
  const [sites, setSites] = useState([]);
  const [filteredSites, setFilteredSites] = useState([]);
  const siteId = sessionStorage.getItem("selectedSiteId");
  console.log(siteId);

  useEffect(() => {
    if (siteId) {
      callUnsetApi(siteId);
      callUnsetApi(siteId);
    }
  }, [siteId]);
  const navigate = useNavigate(); // Initialize navigate function
  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", `/${stateName}/displaySite`);
    }
  }, [navigate]);
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("userDetails");
    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      setUserDetails(parsedData);
    }
  }, []);

  const breadcrumbs = [
    <Link key="1" href="/dashboard" sx={{ color: "black" }}>
      Dashboard
    </Link>,
    <Link key="2" href={`/dashboard`} sx={{ color: "black" }}>
      {stateName}
    </Link>,
    <Typography key="3" sx={{ color: "text.primary" }}>
      Display Sites
    </Typography>,
  ];

  useEffect(() => {
    const fetchSites = async () => {
      const url = `https://api.bharatnet.sunshineiotronics.com/api/v2/heart_bit/list/t1/${stateName}`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        setSites(data);
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    fetchSites();
    const interval = setInterval(fetchSites, 1000); // Update every 1 seconds
    return () => clearInterval(interval); // Cleanup interval
  }, []);

  useEffect(() => {
    const filtered = sites.filter((site) => {
      const matchesSearch =
        (site.site_id &&
          site.site_id.toString().toLowerCase().includes(searchTerm)) ||
        (site.controller_datetime &&
          site.controller_datetime.toLowerCase().includes(searchTerm)) ||
        (site.dist && site.dist.toLowerCase().includes(searchTerm));

      return matchesSearch;
    });
    setFilteredSites(filtered);
  }, [searchTerm, sites]);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleGoLive = (siteId) => {
    sessionStorage.setItem("selectedSiteId", siteId);
    navigate("/get_data_by_site", {
      state: { stateName, siteId },
    });
  };
  const handleHistoricalData = (siteId) => {
    sessionStorage.setItem("selectedSiteId", siteId);
    navigate("/historical_data", {
      state: { stateName, siteId },
    });
  };

  const handleAdditionalControl = (siteId) => {
    sessionStorage.setItem("selectedSiteId", siteId);
    navigate("/additional_control", {
      state: { stateName, siteId },
    });
  };

  const handleAccessControl = (siteId) => {
    sessionStorage.setItem("selectedSiteId", siteId);
    navigate("/access_control", {
      state: { stateName, siteId },
    });
  };

  const renderStatus = (controllerDate) => {
    const currentDate = new Date();

    if (!controllerDate) {
      return (
        <div className="status-indicator offline">
          <span className="status-light"></span>
          <span className="status-text">Offline</span>
        </div>
      );
    }

    const controllerDateTime = new Date(
      controllerDate.split(" ")[0].split("-").reverse().join("-") +
        " " +
        controllerDate.split(" ")[1]
    );

    const diffSeconds = Math.floor((currentDate - controllerDateTime) / 1000);

    return diffSeconds <= 300 ? (
      <div className="status-indicator online">
        <span className="status-light"></span>
        <span className="status-text">Online</span>
      </div>
    ) : (
      <div className="status-indicator offline">
        <span className="status-light"></span>
        <span className="status-text">Offline</span>
      </div>
    );
  };

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <div className="main-panel">
          <div className="content-wrapper">
            <Stack spacing={2}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="medium" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>
          </div>
        </div>
      </div>
      <br />
      {filteredSites.length === 0 ? (
        <div className="no-data-container">
          <Typography
            colSpan="4"
            style={{
              textAlign: "center",
              fontSize: "1.5rem",
              color: "gray",
              marginTop: "20rem",
            }}
          >
            No data available
          </Typography>
        </div>
      ) : (
        <form className="form-control">
          <h2>List Of Sites</h2>
          <div id="searchBarContainer">
            <input
              type="text"
              id="searchBar"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search ..."
              className="search-Bar"
            />
          </div>
          <div className="row my-3">
            <div className="col-md-12">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Site ID</th>
                    <th>Date/Time</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSites.map((site) => (
                    <tr key={site.site_id}>
                      <td className="site-id-container">
                        {site.site_id}
                        {userDetails && userDetails.role === 4 && (
                          <div className="site-id-details">
                            <p>
                              <strong>Mac ID: </strong> {site.mac_id}
                            </p>
                            <p>
                              <strong>CPU Temperature: </strong> {site.cpu_temp}{" "}
                            </p>
                            <p>
                              <strong>CPU Usage:</strong> {site.cpu_usage}
                            </p>
                            <p>
                              <strong>Disk Usage:</strong> {site.disk_usage}
                            </p>
                            <p>
                              <strong>Memory Usage:</strong> {site.memory_usage}
                            </p>
                            <p>
                              <strong>Up Time:</strong>{" "}
                              {Math.floor(site.controller_uptime / 24)} Days{" "}
                              {site.controller_uptime % 24} Hrs
                            </p>

                            <p>
                              <strong>HB(T1) Version:</strong>{" "}
                              {site.hb_t1_version}
                            </p>
                          </div>
                        )}
                      </td>
                      <td>{site.controller_datetime}</td>
                      <td>
                        {renderStatus(
                          site.controller_datetime,
                          site.real_frame_datetime
                        )}
                      </td>
                      <td>
                        <Stack
                          direction="row"
                          spacing={2}
                          style={{ justifyContent: "center" }}
                        >
                          <Button
                            variant="outlined"
                            color={
                              renderStatus(
                                site.controller_datetime
                              ).props.className.includes("online")
                                ? "success"
                                : "error"
                            }
                            onClick={() => handleGoLive(site.site_id)}
                          >
                            Go Live
                          </Button>
                          <Button
                            variant="outlined"
                            color="info"
                            onClick={() => handleHistoricalData(site.site_id)}
                          >
                            Historical Data
                          </Button>
                          <Button
                            variant="outlined"
                            color="warning"
                            onClick={() => handleAccessControl(site.site_id)}
                          >
                            Access Control
                          </Button>
                          <Button
                            variant="outlined"
                            style={{
                              color: "#42D9C8",
                              border: "1px solid #42D9C8",
                            }}
                            onClick={() =>
                              handleAdditionalControl(site.site_id)
                            }
                          >
                            Additional Control
                          </Button>
                        </Stack>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </form>
      )}
    </Box>
  );
};

export default DisplaySite;
